import React, {} from "react"

const paths = require('../../../paths.json');

export default function like_button_click(event, stop_prop, content_id, add_or_delete, data_func, post_data_func) {
    if (stop_prop) {
        event.stopPropagation();
        event.preventDefault();
    }

    data_func(
        paths.BACKEND_URL + "api/like_status_change",
        "post",
        false,
        {
            'content_id': content_id,
            'process': add_or_delete,
            // 'csrfmiddlewaretoken': csrf_token,
        },
        post_data_func,
    )
}
